import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display content as HTML.
 */
@Component({
  selector: 'app-custom-page-content',
  template: `<div class="max-w-screen-lg mx-auto px-8">
    <div class="leading-loose text-justify [&>p+p]:mt-4 [&_a]:text-primary [&_a]:underline [&_a]:font-semibold [&_a:hover]:text-primary-darker" [innerHTML]="data().content"></div>
  </div>`,
  standalone: true,
})
export class CustomPageContentComponent extends CustomPageBlockComponent<'content'> {}
